/* Utils */
import {getCookies} from '../../common/network/apiUtils';
import {experimentCookieListParse} from './experimentUtils';

function experimentApiFactory(storefrontApiClient) {
  const experimentApi = {
    getExperiments(params) {
      const {
        cookieNames,
        cookies = process.env.BROWSER && getCookies(),
      } = params;

      return Promise.resolve(experimentCookieListParse(cookieNames, cookies));
    },
  };

  return experimentApi;
}

export default experimentApiFactory;
